var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content md"},[_c('system-admin',{attrs:{"type":"tablet"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }